import React, { useEffect, useState } from 'react'
import { withTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import BackAnchor from 'shared/components/BackAnchor'
import { changeObjectPropertyAction } from 'redux/actions'
import { useSelector } from 'react-redux'
import { clearDebtAction, clearListInfoAction } from '../../../../redux/actions'

const VehicleTaxDebtView = ({ t, i18n }) => {
  const history = useHistory()
  const dispatch = useDispatch()
  const [prevPage, setPrevPage] = useState('')
  const { debtInformationList } = useSelector((state) => state.app)

  useEffect(() => {
    try {
      if (localStorage.getItem('addAnotherDebtClicked') === 'debtPayment') {
        setPrevPage('routes.debt_info')
        dispatch(clearDebtAction())
      } else if (localStorage.getItem('addAnotherDebtClicked') === 'reviewConfirm') {
        setPrevPage('routes.review_summary')
        dispatch(clearDebtAction())
      } else {
        dispatch(clearListInfoAction('debtInfo'))
      }
    } catch (e) {
      console.error(e)
    }
  }, [])

  const handleClick = (isVehicleTaxDebt) => () => {
    dispatch(changeObjectPropertyAction('debtInformation', 'isVehicleTaxDebt', isVehicleTaxDebt))
    history.push({
      pathname: `/${i18n.language}${t('routes.debt_info')}`,
      state: {
        isVehicleTaxDebt,
      },
    })
  }

  const handleContinueAction = () => {
    history.push(`/${i18n.language}${t(prevPage)}`)
  }

  return (
    <div className="container">
      <main>
        <article className="col-md-8">
          <BackAnchor />
          <div className="row">
            <div className="col-xs-12">
              <h1>{t('vehicle_tax_debt.are_you_paying_vehicle_tax_debt')}</h1>
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12">
              <button
                className="ns-btn-yes-no btn-default"
                style={{ marginRight: '20px' }}
                value={t('screening_question.yes')}
                name={t('screening_question.yes')}
                onClick={handleClick(true)}
              >
                {' '}
                {t('screening_question.yes')}
              </button>
              <button
                className="ns-btn-yes-no btn-default"
                style={{ marginRight: '20px' }}
                value={t('screening_question.no')}
                name={t('screening_question.no')}
                onClick={handleClick(false)}
              >
                {' '}
                {t('screening_question.no')}
              </button>
            </div>
            {debtInformationList.length > 0 && (
              <div className="col-xs-12">
                <button className={['btn-lg btn-default-transparent add-debt-button']} style={{ margin: 0 }} onClick={handleContinueAction}>
                  {t('screening_question.continue_without_adding_debt')}
                </button>
              </div>
            )}
          </div>
        </article>
      </main>
    </div>
  )
}

export default withTranslation('common')(VehicleTaxDebtView)
